import "./search.scss";
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { makeRequest } from "../../utils/axios.js"; 
import Post from "../../components/post/Post";
import ResultItem from "../../components/searchResults/components/ResultItem";
import CircularProgress from '@mui/material/CircularProgress';

const Search = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get("q");
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("all");
    const [users, setUsers] = useState([]);
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchResults = async () => {
            if (!query) return;
            setIsLoading(true);
            try {
                const [userRes, postRes] = await Promise.all([
                    makeRequest.get(`/users/search?name=${query}`), 
                    makeRequest.get(`/posts/search?q=${query}`)    
                ]);
                setUsers(userRes.data);
                setPosts(postRes.data);
            } catch (err) {
                console.error("Search error:", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchResults();
    }, [query]);

    const handleUserClick = (userId) => {
        navigate(`/profile/${userId}`);
    };

    return (
        <div className="search-page">
            <div className="search-container">
                <div className="search-header-container">
                    <h1>
                        Showing results for "{query}"
                    </h1>

                    <div className="tabs">
                        <button 
                            className={activeTab === "all" ? "active" : ""} 
                            onClick={() => setActiveTab("all")}
                        >
                            All
                        </button>

                        <button 
                            className={activeTab === "users" ? "active" : ""} 
                            onClick={() => setActiveTab("users")}
                        >
                            People ({users.length})
                        </button>

                        <button 
                            className={activeTab === "posts" ? "active" : ""} 
                            onClick={() => setActiveTab("posts")}
                        >
                            Post ({posts.length})
                        </button>
                    </div>
                </div>

                {isLoading ? (
                    <div className="loading-container">
                        <CircularProgress />
                    </div>
                ) : (
                    <div className="search-results-container">
                        {(activeTab === "all" || activeTab === "users") && (
                            <div className="section">
                                {activeTab === "all" &&
                                    <h3>
                                        People
                                    </h3>
                                }

                                <div className="users-list">
                                    {users.length > 0 ? (
                                        users.map(user => (
                                            <div key={user.id} className="user-card">
                                                <ResultItem 
                                                    item={{ ...user, type: 'user' }} 
                                                    onClick={() => handleUserClick(user.id)}
                                                />
                                            </div>
                                        ))
                                    ) : activeTab === "users" && 
                                        <p>
                                            No users found.
                                        </p>
                                    }
                                </div>
                            </div>
                        )}

                        {(activeTab === "all" || activeTab === "posts") && (
                            <div className="section">
                                {activeTab === "all" && 
                                    <h3>
                                        Article
                                    </h3>
                                }

                                <div className="posts-list">
                                    {posts.length > 0 ? (
                                        posts.map(post => (
                                            <Post post={post} key={post.id} />
                                        ))
                                    ) : activeTab === "posts" && 
                                        <p>
                                            No articles were found.
                                        </p>
                                    }
                                </div>
                            </div>
                        )}

                        {users.length === 0 && posts.length === 0 && !isLoading && (
                            <div className="no-results">
                                <p>
                                    Unfortunately, no results were found for this keyword.
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Search;